import { toSentenceCase } from '@noths/polaris-client-utils';

import type { Facet } from 'src/redux/productsQuery/types/Facet';
import type { SortOption } from 'src/redux/productsQuery/types/SortOption';
import { BrowseDataAPIFilterUID } from 'src/services/browse-data-api/constants/BrowseDataAPIFilterUID';

export const getFacetsWithSortAsAFacet = (facets: Facet[], sortOptions: SortOption[]) => {
  const sortFacet: Facet = {
    active: false,
    options: sortOptions.map(({ active, id, title }) => ({
      uid: id,
      value: id,
      title: toSentenceCase(title),
      active,
      activeCount: null,
      minValue: null,
      maxValue: null,
    })),
    title: 'Sort',
    type: 'radio',
    uid: BrowseDataAPIFilterUID.Sort,
  };

  return [sortFacet, ...facets];
};
